<template>
  <v-dialog
    v-model="dialogProdutosSilenciados"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="#042333">
        <v-btn icon dark @click="setDialogProdutosSilenciados(false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Produtos com Notificação Silenciada </v-toolbar-title>

        <v-spacer />

        <v-btn color="primary" title="Exportar Para Excel" @click="relatorio()" small>
          <v-icon left>mdi-file-export</v-icon>
          Exportar
        </v-btn>
      </v-toolbar>

      <sys-data-table
        v-model="produtosSelecionados"
        :headers="headers"
        :items="itens"
        :search="pesquisaProduto"
        :fixed-header="true"
        :item-height="45"
        :height="altura_janela_computed - 163"
        class="elevation-0 table-full-screen"
        show-select
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <h4>{{ titulo }}</h4>

            <v-spacer></v-spacer>

            <template v-if="produtosSelecionados.length">
              <v-btn color="error" class="mr-8" small @click="delecaoMultiplaDeProdutoSilenciados()">
                <v-icon left>mdi-delete</v-icon>
                <span>Remover</span>
                <span class="qtde-top-button-small">{{produtosSelecionados.length}}</span>
              </v-btn>
            </template>

            <v-text-field
              v-model="pesquisaProduto"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              clearable
              hide-details
              style="max-width: 450px"
            ></v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:item.filial="{item}">
          {{ getFilialCompras > 0 ? item.descricao_filial : 'Geral'}}
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon
            @click="editar(item)"
            title="Editar data final da não notificação do produto"
            >mdi-pencil</v-icon
          >
          <v-icon
            @click="deletar(item)"
            title="Ao excluir você reativa a notificação do produto"
            >mdi-delete</v-icon
          >
        </template>
      </sys-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import $axios from './../../api/api.js'
import {useResize} from "@/helpers/Resize";



export default {
  data() {
    return {
      pesquisaProduto: '',
      produtosSelecionados: [],
      headers: [
        { text: "Grupo", value: "descricao" },
        { text: "Filial", value: "filial" },
        { text: "Fornecedor", value: "fornecedor" },
        { text: "Marca", value: "marca" },
        { text: "ID Produto", value: "idproduto" },
        { text: "Produto", value: "descricao_produto" },
        { text: "ID Usuário", value: "log_user" },
        { text: "Nome Usuário", value: "user_name" },
        { text: "Data Limite", value: "data_limite" },
        { text: "", value: "action", sortable: false },
      ],

    };
  },
  computed: {
    ...mapGetters({
      getComprador: "fornecedor/getComprador"
    }),
    ...mapGetters("fornecedor", ["getFornecedor"]),
    ...mapGetters("usuario", ["getGrupoCompras", "getFilialCompras"]),
    ...mapGetters("notificacaoProdutoSilenciado", ["itens", "titulo"]),
    dialogProdutosSilenciados: {
      get() {
        return this.$store.state.app.dialogProdutosSilenciados;
      },
      set(val) {
        this.$store.commit("app/setDialogProdutosSilenciados", val);
      },
    },
    altura_janela_computed() {
      const { altura_janela } = useResize();
      return altura_janela.value;
    }
  },
  methods: {
    ...mapMutations("app", ["setDialogProdutosSilenciados"]),
    ...mapMutations("notificacaoProdutoSilenciado", [
      "setProdutoSilenciadoEditar",
    ]),
    editar(item) {
      this.setProdutoSilenciadoEditar(item);
    },
    deletar(item) {
      if (confirm("Deseja realmente exluir esse registro?")) {
        this.$store.dispatch("notificacaoProdutoSilenciado/Delete", {
          id: item.id,
          grupo: this.getGrupoCompras,
          filial: this.getFilialCompras,
          fornecedor: this.getFornecedor.id,
          analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
        });
      }
    },
    delecaoMultiplaDeProdutoSilenciados () {
      const length = this.produtosSelecionados.length

      const confirmado = window.confirm(`Deseja realmente excluir o${length > 1 ? 's' : ''} ite${length > 1 ? 'ns' : 'm'} selecionado${length > 1 ? 's' : ''}`)

      if (confirmado) {
        const params = {
          grupo: this.getGrupoCompras,
          filial: this.getFilialCompras,
          fornecedor: this.getFornecedor.id,
          produtos: [],
          analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
        }

        this.produtosSelecionados.forEach(item => params.produtos.push({id: item.id}))

        this.$store.dispatch("loadingAux/habilitarLoading", true);

        this.$store.dispatch("notificacaoProdutoSilenciado/delecaoMultiplaDeProdutoSilenciados", params)
          .finally(() => this.$store.dispatch("loadingAux/habilitarLoading", false));
      }

      this.produtosSelecionados = []
    },
    relatorio() {
      let url = "relatorio_produtos_silenciados?";
      url += "grupo=" + this.getGrupoCompras;
      url += "&filial=" + this.getFilialCompras;
      url += "&fornecedor=" + this.getFornecedor.id;
      url += "&analiseGrupoFornecedores=" + localStorage.analiseGrupoFornecedores;
      window.open($axios.defaults.baseURL + "/" + url, "_blank");
    },
  },
  watch: {
    dialogProdutosSilenciados() {
      const params = {
        grupo: this.getGrupoCompras,
        filial: this.getFilialCompras,
        comprador: this.getComprador,
        fornecedor: this.getFornecedor.id,
        analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
      };

      if (this.dialogProdutosSilenciados) {
        this.$store.dispatch("notificacaoProdutoSilenciado/Itens", params);
      }
    },
    itens () {
      this.itens.length == 0 && (this.setDialogProdutosSilenciados(false))
    },
  },
};
</script>
<style>
.footer-margin-0 .v-data-footer {
  margin-right: 0px !important;
}
</style>
